import React from "react";

const stats = [
  { value: "50k+", label: "Successful test takers" },
  { value: "30+", label: "Practice modules" },
  { value: "500k+", label: "AI insights delivered" },
];

export default function Stats() {
  return (
    <section className="bg-gray-50 px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-gray-500">
            Results at scale
          </p>
          <h3 className="mt-3 text-3xl font-black tracking-tight text-gray-950 sm:text-4xl">
            Trusted by aspiring test takers worldwide.
          </h3>

          <p className="mt-4 text-base leading-7 text-gray-600 sm:text-lg">
            PrepNexis AI gives students the tools, feedback, and practice
            structure they need to prepare with confidence.
          </p>
        </div>

        <dl className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-gray-200 bg-white px-6 py-8 text-center shadow-sm"
            >
              <dd className="text-4xl font-black text-gray-950 md:text-5xl">
                {stat.value}
              </dd>
              <dt className="mt-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
                {stat.label}
              </dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
